import { render, staticRenderFns } from "./SmartTV.vue?vue&type=template&id=ab2c2424&scoped=true&"
import script from "./SmartTV.vue?vue&type=script&lang=js&"
export * from "./SmartTV.vue?vue&type=script&lang=js&"
import style0 from "./SmartTV.vue?vue&type=style&index=0&id=ab2c2424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2c2424",
  null
  
)

export default component.exports